import { render, staticRenderFns } from "./UAMPage.vue?vue&type=template&id=775b7f2e"
import script from "./UAMPage.vue?vue&type=script&lang=js"
export * from "./UAMPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports